'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEventName = exports.eventNames = exports.props = exports.EVENT_SECURITY_OAUTH_REFRESH = exports.EVENT_SECURITY_SETTINGS_OAUTH = exports.EVENT_SECURITY_AUTHENTICATE_OAUTH = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _Event = require('../Core/Event');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EVENT_SECURITY_AUTHENTICATE_OAUTH = exports.EVENT_SECURITY_AUTHENTICATE_OAUTH = 'security.authenticate.oauth'; /**
                                                                                                                    * Defines events and related functionality which handle the security aspects of the application
                                                                                                                    *
                                                                                                                    * @module Security/events
                                                                                                                    */

var EVENT_SECURITY_SETTINGS_OAUTH = exports.EVENT_SECURITY_SETTINGS_OAUTH = 'security.settings.oauth';

var EVENT_SECURITY_OAUTH_REFRESH = exports.EVENT_SECURITY_OAUTH_REFRESH = 'security.oauth.refresh';

var events = {
  EVENT_SECURITY_AUTHENTICATE_OAUTH: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE },
  EVENT_SECURITY_OAUTH_REFRESH: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE },
  EVENT_SECURITY_SETTINGS_OAUTH: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE }
};

/**
 * @readonly
 * @enum
 * @type {{EVENT_SECURITY_AUTHENTICATE_OAUTH: {channelType: string, invocationType: string}, EVENT_SECURITY_OAUTH_REFRESH: {channelType: string, invocationType: string}, EVENT_SECURITY_SETTINGS_OAUTH: {channelType: string, invocationType: string}}}
 */
var props = exports.props = events;

/**
 * @readonly
 * @type {Array}
 */
var eventNames = exports.eventNames = (0, _keys2.default)(events).map(function (key) {
  return events[key];
});

/**
 * @method
 * @param {String} name
 * @return {boolean}
 */
var isEventName = exports.isEventName = function isEventName(name) {
  return eventNames.indexOf(name) !== -1;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Security/events.js
// module id = 160
// module chunks = 0